import React from 'react';

export const EmptyCollection = () => (
  <svg width={157} height={150} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="#fff" d="M0 0h150v150H0z" />
    <path
      d="M148 66a9.26 9.26 0 0 0 9 9 9.26 9.26 0 0 0-9 9 9.26 9.26 0 0 0-9-9 9.26 9.26 0 0 0 9-9ZM77.5 98c.188 6.824 5.676 12.312 12.5 12.5-6.824.188-12.312 5.676-12.5 12.5-.188-6.824-5.676-12.312-12.5-12.5 6.824-.188 12.312-5.676 12.5-12.5ZM25.5 32a7.716 7.716 0 0 0 7.5 7.5 7.716 7.716 0 0 0-7.5 7.5 7.716 7.716 0 0 0-7.5-7.5 7.716 7.716 0 0 0 7.5-7.5Z"
      fill="#1F1F1F"
    />
    <path
      d="M17.167 66.576c4.579 0 2.311 18.372 4.579 18.372 2.538 0 3.694-28.87 6.54-28.87 2.69 0 2.75 42.649 5.888 42.649 3.137 0 3.859-57.74 6.541-57.74 2.793 0 1.94 72.175 5.887 72.175 3.719 0 3.536-72.175 6.542-72.175 3.017 0 2.53 57.74 5.887 57.74 3.882 0 2.72-42.65 5.887-42.65 3.166 0 3.528 28.87 6.54 28.87 3.014 0 3.379-18.37 6.542-18.37 2.92 0 3.042 18.37 5.887 18.37 3.056 0 3.36-28.87 6.541-28.87 3.182 0 2.294 42.65 5.888 42.65 3.593 0 3.037-57.74 5.887-57.74 3.05 0 2.503 72.175 6.541 72.175 3.749 0 2.714-72.175 5.887-72.175 3.032 0 2.081 57.74 6.541 57.74 4.461 0 1.723-42.65 5.887-42.65s3.894 28.87 5.887 28.87c1.994 0 .732-18.37 5.887-18.37"
      stroke="#0F0F0F"
      strokeWidth={0.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
